import { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles, Shirt, ArrowRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_lava-refresh/artifacts/cr75vzod_logo%20kilolava.png";

const HomePage = () => {
  const [hoveredSide, setHoveredSide] = useState(null);

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Split Screen */}
      <div className="relative min-h-[calc(100vh-80px)] flex flex-col lg:flex-row">
        {/* Pulizie Side */}
        <Link
          to="/pulizie"
          className={`relative flex-1 flex items-center justify-center overflow-hidden transition-all duration-500 cursor-pointer group ${
            hoveredSide === 'lavanderia' ? 'lg:flex-[0.4]' : hoveredSide === 'pulizie' ? 'lg:flex-[0.6]' : ''
          }`}
          onMouseEnter={() => setHoveredSide('pulizie')}
          onMouseLeave={() => setHoveredSide(null)}
          data-testid="home-pulizie-card"
        >
          {/* Background Image */}
          <div 
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
            style={{
              backgroundImage: `url(https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?w=1200&q=80)`,
            }}
          />
          {/* Overlay */}
          <div className={`absolute inset-0 bg-gradient-to-br from-primary/90 to-primary/70 transition-opacity duration-500 ${
            hoveredSide === 'lavanderia' ? 'opacity-95' : 'opacity-85'
          }`} />

          {/* Content */}
          <motion.div 
            className="relative z-10 text-center text-white p-8 max-w-lg"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
              <Sparkles className="w-10 h-10" />
            </div>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
              PULIZIE
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-6">
              Case vacanza, Hotel, Uffici, Condomini
            </p>
            <div className="flex items-center justify-center gap-2 text-white/80 group-hover:text-white transition-colors">
              <span className="font-medium">Scopri di più</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
            </div>
          </motion.div>
        </Link>

        {/* Lavanderia Side */}
        <Link
          to="/lavanderia"
          className={`relative flex-1 flex items-center justify-center overflow-hidden transition-all duration-500 cursor-pointer group ${
            hoveredSide === 'pulizie' ? 'lg:flex-[0.4]' : hoveredSide === 'lavanderia' ? 'lg:flex-[0.6]' : ''
          }`}
          onMouseEnter={() => setHoveredSide('lavanderia')}
          onMouseLeave={() => setHoveredSide(null)}
          data-testid="home-lavanderia-card"
        >
          {/* Background Image */}
          <div 
            className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
            style={{
              backgroundImage: `url(https://images.unsplash.com/photo-1582735689369-4fe89db7114c?w=1200&q=80)`,
            }}
          />
          {/* Overlay */}
          <div className={`absolute inset-0 bg-gradient-to-br from-text-primary/90 to-text-primary/70 transition-opacity duration-500 ${
            hoveredSide === 'pulizie' ? 'opacity-95' : 'opacity-85'
          }`} />

          {/* Content */}
          <motion.div 
            className="relative z-10 text-center text-white p-8 max-w-lg"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
              <Shirt className="w-10 h-10" />
            </div>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold mb-4">
              LAVANDERIA
            </h2>
            <p className="text-lg md:text-xl text-white/90 mb-6">
              Biancheria e Tovagliato
            </p>
            <div className="flex items-center justify-center gap-2 text-white/80 group-hover:text-white transition-colors">
              <span className="font-medium">Scopri di più</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
            </div>
          </motion.div>
        </Link>
      </div>

      {/* Bottom Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-text-primary mb-6">
              Servizi Professionali a <span className="text-primary">Trieste</span>
            </h2>
            <p className="text-lg text-text-secondary max-w-2xl mx-auto">
              Kilolava offre servizi di pulizia e lavanderia per strutture ricettive, uffici e ristoranti. 
              Qualità, affidabilità e professionalità al tuo servizio.
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
